// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface VapiConfigOut {}

export const VapiConfigOutSerializer = {
  _fromJsonObject(_object: any): VapiConfigOut {
    return {};
  },

  _toJsonObject(_self: VapiConfigOut): any {
    return {};
  },
};
